import { createAction } from '@reduxjs/toolkit';

export interface KanbanBoardState {
    KanbanLanes: any
    CandidateStages: any
    GroupedSubStages: any
}

export const initialState: KanbanBoardState = {
    KanbanLanes: {},
    CandidateStages: {},
    GroupedSubStages: {}
}

export const setKanbanLanes = createAction<any>('kanbanBoard/setKanbanLanes');
export const setCandidateStages = createAction<any>('kanbanBoard/setCandidateStages');
export const setGroupedSubStages = createAction<any>('kanbanBoard/setGroupedSubStages');